import React, { Fragment, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { checkLoggedIn } from "../../utils";
import {
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  addUserCart,
} from "../../store/actions/action";
import Footer from "../../components/footer/Footer";
import Recomended from "../../components/Recomended/Recomended";
import axios from "axios";
import CartProductRow from "./CartProductRow";
import { useLoginModal } from "../../Context/LoginModalContext";

const CartPage = (props) => {
  const { carts, token, configs } = props;
  const { isAuth } = configs;
  const { openLoginModal } = useLoginModal();

  const totalPrices = (carts || []).reduce(
    (acc, item) => acc + (Number(item?.price) || 0) * (Number(item?.qty) || 0),
    0
  );
  const grandTotal = totalPrices;
  const itemCount = (carts || []).reduce((a, it) => a + (Number(it?.qty) || 0), 0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getUserCartData = async () => {
    setLoading(true);
    if (error) setError(false);
    await axios
      .get("get-cart", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        props?.addUserCart({
          cart: res?.data?.cartDetails,
          totalPrice: res?.data?.totalPrice,
          totalQuantity: res?.data?.totalQuantity,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  };

  useEffect(() => {
    if (checkLoggedIn()) getUserCartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  const currencySymbols = { EUR: "€", USD: "$", AED: "AED" };
  const currencyCode = localStorage.getItem("currency") || "AED";
  const currencyPrefix = currencySymbols[currencyCode] ? currencySymbols[currencyCode] + " " : "AED ";

  const isEmpty = !loading && (!carts || carts.length === 0);

  return (
    <Fragment>
      <Navbar />

      <section className="gpcart-section">
        <div className="gpcart-bg-orb gpcart-bg-orb-tl" />
        <div className="gpcart-bg-orb gpcart-bg-orb-br" />

        <div className="gpcart-inner">
          <div className="gpcart-head">
            <div className="gpcart-eyebrow">
              <span className="gpcart-eyebrow-dot" />
              YOUR CART
            </div>
            <h1 className="gpcart-title">
              Review your <span className="gpcart-title-accent">selections</span>
            </h1>
            <p className="gpcart-sub">
              {isEmpty
                ? "Discover trending gift cards and add what you love."
                : `${itemCount} ${itemCount === 1 ? "item" : "items"} ready for instant delivery.`}
            </p>
          </div>

          {loading ? (
            <div className="gpcart-skeleton-wrap">
              {[0, 1, 2].map((i) => (
                <div className="gpcart-skeleton-row" key={i}>
                  <div className="gpcart-sk-thumb" />
                  <div className="gpcart-sk-meta">
                    <div className="gpcart-sk-line gpcart-sk-line-lg" />
                    <div className="gpcart-sk-line gpcart-sk-line-sm" />
                  </div>
                  <div className="gpcart-sk-line gpcart-sk-line-md" />
                </div>
              ))}
            </div>
          ) : isEmpty ? (
            <div className="gpcart-empty">
              <div className="gpcart-empty-card">
                <div className="gpcart-empty-icon">
                  <svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="9" cy="21" r="1" />
                    <circle cx="20" cy="21" r="1" />
                    <path d="M1 1h4l2.7 13.4a2 2 0 002 1.6h9.7a2 2 0 002-1.6L23 6H6" />
                  </svg>
                </div>
                <h2>Your cart is empty</h2>
                <p>Start adding gift cards you'd love to send or use yourself.</p>
                <Link to="/shop" className="gpcart-empty-cta">
                  <span>Browse Gift Cards</span>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </Link>
              </div>

              <div className="gpcart-empty-recos">
                <div className="gpcart-section-head">
                  <h3>Hand-picked for you</h3>
                </div>
                <Recomended />
              </div>
            </div>
          ) : (
            <div className="gpcart-grid">
              {/* LEFT: Items */}
              <div className="gpcart-col-left">
                <div className="gpcart-card">
                  <div className="gpcart-card-head">
                    <h2>Cart Items</h2>
                    <span className="gpcart-pill">{itemCount} {itemCount === 1 ? "item" : "items"}</span>
                  </div>

                  <div className="gpcart-rows-head">
                    <span>Product</span>
                    <span>Price</span>
                    <span>Quantity</span>
                    <span>Subtotal</span>
                    <span />
                  </div>

                  <div className="gpcart-rows-list">
                    {carts?.map((cartItem, idx) => (
                      <CartProductRow
                        getUserCartData={getUserCartData}
                        cartItem={cartItem}
                        key={cartItem.id || idx}
                        {...props}
                      />
                    ))}
                  </div>

                  <div className="gpcart-card-foot">
                    <Link to="/shop" className="gpcart-continue">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="19" y1="12" x2="5" y2="12" />
                        <polyline points="12 19 5 12 12 5" />
                      </svg>
                      Continue Shopping
                    </Link>
                  </div>
                </div>
              </div>

              {/* RIGHT: Summary */}
              <div className="gpcart-col-right">
                <div className="gpcart-summary">
                  <div className="gpcart-summary-head">
                    <h2>Order Summary</h2>
                  </div>

                  <div className="gpcart-summary-rows">
                    <div className="gpcart-summary-row">
                      <span>Subtotal ({itemCount} {itemCount === 1 ? "item" : "items"})</span>
                      <span>{currencyPrefix}{totalPrices.toFixed(2)}</span>
                    </div>
                    <div className="gpcart-summary-row">
                      <span>Delivery</span>
                      <span className="gpcart-summary-free">Free · Instant</span>
                    </div>
                    <div className="gpcart-summary-row gpcart-summary-row-total">
                      <span>Total</span>
                      <span className="gpcart-summary-total-amt">
                        {currencyPrefix}{Number(grandTotal).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  {checkLoggedIn() ? (
                    <Link to="/checkout" className="gpcart-checkout-btn">
                      <span>Proceed to Checkout</span>
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </Link>
                  ) : (
                    <button
                      type="button"
                      onClick={openLoginModal}
                      className="gpcart-checkout-btn"
                    >
                      <span>Login to Checkout</span>
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </button>
                  )}

                  <div className="gpcart-trust">
                    <div className="gpcart-trust-item">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" /></svg>
                      Secure Payment
                    </div>
                    <div className="gpcart-trust-item">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" /></svg>
                      Instant Delivery
                    </div>
                    <div className="gpcart-trust-item">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
                      Verified Codes
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!isEmpty && !loading && (
            <div className="gpcart-recos-block">
              <div className="gpcart-section-head">
                <div className="gpcart-eyebrow">
                  <span className="gpcart-eyebrow-dot" />
                  YOU MIGHT ALSO LIKE
                </div>
                <h3>Hand-picked for you</h3>
              </div>
              <Recomended />
            </div>
          )}
        </div>

        <style>{`
          .gpcart-section {
            position: relative;
            background: linear-gradient(180deg, #07060a 0%, #0b0b0c 100%);
            color: #e6e8ec;
            padding: 60px 22px 90px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            overflow: hidden;
            min-height: 100vh;
          }
          .gpcart-bg-orb {
            position: absolute;
            width: 420px;
            height: 420px;
            border-radius: 50%;
            filter: blur(130px);
            opacity: 0.45;
            pointer-events: none;
          }
          .gpcart-bg-orb-tl { background: rgba(212,168,87,0.18); top: -160px; left: -120px; }
          .gpcart-bg-orb-br { background: rgba(212,168,87,0.12); bottom: -180px; right: -120px; }

          .gpcart-inner {
            position: relative;
            max-width: 1200px;
            margin: 0 auto;
            z-index: 1;
          }

          .gpcart-head { text-align: center; margin-bottom: 38px; }
          .gpcart-eyebrow {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 6px 14px;
            background: rgba(212,168,87,0.1);
            border: 1px solid rgba(212,168,87,0.3);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 2px;
            margin-bottom: 14px;
          }
          .gpcart-eyebrow-dot {
            width: 6px; height: 6px; border-radius: 50%;
            background: #d4a857;
            box-shadow: 0 0 10px #d4a857;
            animation: gpcart-pulse 1.6s ease-in-out infinite;
          }
          @keyframes gpcart-pulse {
            0%,100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.55; transform: scale(0.85); }
          }
          .gpcart-title {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 36px;
            font-weight: 700;
            color: #fff;
            margin: 0 0 10px;
            line-height: 1.2;
          }
          .gpcart-title-accent {
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-style: italic;
            font-weight: 600;
          }
          .gpcart-sub { font-size: 14px; color: #9aa0a8; max-width: 560px; margin: 0 auto; line-height: 1.6; }

          .gpcart-grid {
            display: grid;
            grid-template-columns: 1fr 360px;
            gap: 22px;
            align-items: flex-start;
          }

          .gpcart-card,
          .gpcart-summary {
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.22);
            border-radius: 18px;
            padding: 24px;
            box-shadow: 0 12px 30px rgba(0,0,0,0.35);
          }
          .gpcart-card-head,
          .gpcart-summary-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 18px;
            padding-bottom: 14px;
            border-bottom: 1px solid rgba(212,168,87,0.15);
          }
          .gpcart-card-head h2,
          .gpcart-summary-head h2 {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 20px;
            color: #fff;
            margin: 0;
            font-weight: 700;
          }
          .gpcart-pill {
            padding: 5px 12px;
            background: rgba(212,168,87,0.12);
            border: 1px solid rgba(212,168,87,0.28);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          /* Header above rows (desktop) */
          .gpcart-rows-head {
            display: grid;
            grid-template-columns: 1.6fr 0.7fr 0.9fr 0.8fr 36px;
            gap: 14px;
            align-items: center;
            padding: 0 14px 10px;
            font-size: 11px;
            text-transform: uppercase;
            letter-spacing: 1.4px;
            color: #6e7480;
            font-weight: 700;
            border-bottom: 1px dashed rgba(212,168,87,0.15);
            margin-bottom: 10px;
          }

          .gpcart-rows-list { display: flex; flex-direction: column; gap: 10px; }

          /* Row */
          .gpcart-row {
            display: grid;
            grid-template-columns: 64px 1.4fr 0.7fr 0.9fr 0.8fr 36px;
            gap: 14px;
            align-items: center;
            padding: 14px;
            background: rgba(255,255,255,0.02);
            border: 1px solid rgba(255,255,255,0.06);
            border-radius: 14px;
            transition: border-color .25s ease, background .25s ease, transform .2s ease;
          }
          .gpcart-row:hover {
            border-color: rgba(212,168,87,0.3);
            background: rgba(212,168,87,0.04);
            transform: translateY(-1px);
          }
          .gpcart-row-thumb {
            width: 64px;
            height: 64px;
            border-radius: 12px;
            overflow: hidden;
            background: #0b0b0c;
            border: 1px solid rgba(212,168,87,0.2);
          }
          .gpcart-row-thumb img { width: 100%; height: 100%; object-fit: cover; }
          .gpcart-row-meta { min-width: 0; }
          .gpcart-row-title {
            font-size: 14.5px;
            color: #fff;
            font-weight: 600;
            margin: 0;
            line-height: 1.35;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .gpcart-row-price-mobile { display: none; font-size: 13px; color: #d4a857; font-weight: 700; margin-top: 4px; }
          .gpcart-row-label { display: none; font-size: 11px; color: #6e7480; text-transform: uppercase; letter-spacing: 1px; font-weight: 700; }
          .gpcart-row-val { font-size: 14px; color: #fff; font-weight: 600; }
          .gpcart-row-subval {
            font-size: 15px;
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            font-weight: 700;
          }

          /* Stepper */
          .gpcart-stepper {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 4px;
            background: rgba(0,0,0,0.35);
            border: 1px solid rgba(212,168,87,0.22);
            border-radius: 10px;
          }
          .gpcart-step-btn {
            width: 28px;
            height: 28px;
            background: transparent;
            color: #d4a857;
            border: 1px solid rgba(212,168,87,0.25);
            border-radius: 7px;
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background .2s ease, border-color .2s ease;
          }
          .gpcart-step-btn:hover:not(:disabled) {
            background: rgba(212,168,87,0.12);
            border-color: rgba(212,168,87,0.5);
          }
          .gpcart-step-btn:disabled { opacity: 0.7; cursor: not-allowed; }
          .gpcart-step-val {
            min-width: 22px;
            text-align: center;
            font-size: 14px;
            font-weight: 700;
            color: #fff;
          }

          /* Remove button */
          .gpcart-row-remove {
            width: 36px;
            height: 36px;
            background: rgba(255,80,80,0.08);
            color: #ff7a7a;
            border: 1px solid rgba(255,80,80,0.2);
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background .2s ease, border-color .2s ease, transform .2s ease;
          }
          .gpcart-row-remove:hover:not(:disabled) {
            background: rgba(255,80,80,0.16);
            border-color: rgba(255,80,80,0.45);
            transform: translateY(-1px);
          }
          .gpcart-row-remove:disabled { opacity: 0.7; cursor: not-allowed; }

          .gpcart-card-foot {
            margin-top: 18px;
            padding-top: 14px;
            border-top: 1px dashed rgba(212,168,87,0.15);
          }
          .gpcart-continue {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            color: #d4a857;
            font-size: 13px;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-decoration: none;
            transition: gap .2s ease, color .2s ease;
          }
          .gpcart-continue:hover {
            color: #f1cf85;
            gap: 12px;
            text-decoration: none;
          }

          /* SUMMARY */
          .gpcart-summary { position: sticky; top: 110px; }
          .gpcart-summary-rows { display: flex; flex-direction: column; gap: 10px; margin-bottom: 18px; }
          .gpcart-summary-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            color: #c5c8cf;
          }
          .gpcart-summary-row span:last-child { color: #fff; font-weight: 600; }
          .gpcart-summary-free { color: #4ade80 !important; font-size: 12.5px; font-weight: 700 !important; }
          .gpcart-summary-row-total {
            margin-top: 8px;
            padding-top: 14px;
            border-top: 1px solid rgba(212,168,87,0.22);
          }
          .gpcart-summary-row-total span:first-child {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 17px;
            color: #fff;
            font-weight: 700;
          }
          .gpcart-summary-total-amt {
            font-size: 22px !important;
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent !important;
            font-weight: 700 !important;
          }

          .gpcart-checkout-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            width: 100%;
            padding: 15px;
            background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
            color: #0b0b0c;
            border: none;
            border-radius: 12px;
            font-size: 14px;
            font-weight: 800;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            cursor: pointer;
            text-decoration: none;
            transition: transform .2s ease, box-shadow .25s ease;
            min-height: 52px;
          }
          .gpcart-checkout-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 14px 30px rgba(212,168,87,0.35);
            color: #0b0b0c;
            text-decoration: none;
          }

          .gpcart-trust {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            margin-top: 16px;
            padding: 12px;
            background: rgba(255,255,255,0.02);
            border: 1px dashed rgba(212,168,87,0.18);
            border-radius: 12px;
          }
          .gpcart-trust-item {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            font-size: 11px;
            color: #d4a857;
            font-weight: 700;
            letter-spacing: 0.3px;
            text-transform: uppercase;
          }

          /* EMPTY */
          .gpcart-empty { display: flex; flex-direction: column; gap: 32px; }
          .gpcart-empty-card {
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.22);
            border-radius: 20px;
            padding: 60px 30px;
            text-align: center;
            box-shadow: 0 12px 30px rgba(0,0,0,0.35);
          }
          .gpcart-empty-icon {
            width: 90px;
            height: 90px;
            margin: 0 auto 20px;
            background: rgba(212,168,87,0.1);
            border: 1px solid rgba(212,168,87,0.28);
            color: #d4a857;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .gpcart-empty-card h2 {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 28px;
            color: #fff;
            margin: 0 0 8px;
            font-weight: 700;
          }
          .gpcart-empty-card p { font-size: 14px; color: #9aa0a8; margin: 0 0 22px; }
          .gpcart-empty-cta {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 13px 28px;
            background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
            color: #0b0b0c;
            font-size: 13px;
            font-weight: 800;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            border-radius: 12px;
            text-decoration: none;
            transition: transform .2s ease, box-shadow .25s ease, gap .2s ease;
          }
          .gpcart-empty-cta:hover {
            transform: translateY(-2px);
            box-shadow: 0 14px 30px rgba(212,168,87,0.35);
            color: #0b0b0c;
            text-decoration: none;
            gap: 12px;
          }

          /* RECOS section */
          .gpcart-recos-block { margin-top: 50px; }
          .gpcart-section-head { text-align: center; margin-bottom: 24px; }
          .gpcart-section-head h3 {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 26px;
            color: #fff;
            font-weight: 700;
            margin: 10px 0 0;
          }

          .gpcart-empty-recos .gpcart-section-head h3 { margin-bottom: 16px; }

          /* SKELETON */
          .gpcart-skeleton-wrap { display: flex; flex-direction: column; gap: 12px; max-width: 820px; margin: 0 auto; }
          .gpcart-skeleton-row {
            display: grid;
            grid-template-columns: 64px 1fr 100px;
            gap: 14px;
            align-items: center;
            padding: 16px;
            background: linear-gradient(180deg, #15110a 0%, #1a1208 100%);
            border: 1px solid rgba(212,168,87,0.12);
            border-radius: 14px;
          }
          .gpcart-sk-thumb { width: 64px; height: 64px; border-radius: 12px; background: rgba(255,255,255,0.05); animation: gpcart-shimmer 1.4s ease infinite; }
          .gpcart-sk-meta { display: flex; flex-direction: column; gap: 8px; }
          .gpcart-sk-line { height: 12px; border-radius: 6px; background: rgba(255,255,255,0.05); animation: gpcart-shimmer 1.4s ease infinite; }
          .gpcart-sk-line-lg { width: 70%; }
          .gpcart-sk-line-sm { width: 40%; height: 10px; }
          .gpcart-sk-line-md { width: 80px; }
          @keyframes gpcart-shimmer {
            0%, 100% { opacity: 0.5; }
            50% { opacity: 1; }
          }

          @media (max-width: 1100px) {
            .gpcart-grid { grid-template-columns: 1fr; }
            .gpcart-summary { position: static; }
          }

          @media (max-width: 820px) {
            .gpcart-rows-head { display: none; }
            .gpcart-row {
              grid-template-columns: 64px 1fr auto;
              row-gap: 12px;
            }
            .gpcart-row-thumb { grid-row: 1 / span 2; }
            .gpcart-row-meta { grid-column: 2 / span 2; }
            .gpcart-row-price-mobile { display: block; }
            .gpcart-row-price { display: none; }
            .gpcart-row-qty {
              grid-column: 2;
              display: flex;
              flex-direction: column;
              gap: 6px;
              align-items: flex-start;
            }
            .gpcart-row-subtotal {
              grid-column: 3;
              display: flex;
              flex-direction: column;
              gap: 6px;
              align-items: flex-end;
              text-align: right;
            }
            .gpcart-row-label { display: block; }
            .gpcart-row-remove {
              grid-row: 1;
              grid-column: 3;
              align-self: start;
              justify-self: end;
            }
          }

          @media (max-width: 575px) {
            .gpcart-section { padding: 40px 14px 70px; }
            .gpcart-card, .gpcart-summary { padding: 20px; }
            .gpcart-title { font-size: 26px; }
            .gpcart-empty-card { padding: 40px 20px; }
            .gpcart-empty-card h2 { font-size: 22px; }
            .gpcart-trust { flex-wrap: wrap; justify-content: center; }
          }
        `}</style>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
    configs: state.configs,
    token: state.configs?.token,
  };
};

export default connect(mapStateToProps, {
  addUserCart,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
})(CartPage);
